<template>
  <div class="home survey-results font_Montserrat v3_color_black_knight">
    <div class="survey-results__content">
      <div class="mobile-responsive-padding-box" v-if="this.showData">
        <!--        <h2 class="font_size_1000rem font_weight_bold mobile-responsive-heading">-->
        <!--          <template v-if="specialty">-->
        <!--            Specialty: {{ specialtyTitle }}-->
        <!--          </template>-->
        <!--          <template v-if="subspecialty">-->
        <!--            / Subspecialty: {{ subspecialtyTitle }}-->
        <!--          </template>-->
        <!--        </h2>-->

        <!---- Filters Start --->
        <div class="mt-4">
            <div>
                <!-- Specialty Filter -->
                <b-row class="mt-4" v-if="this.specialties.length > 0"> 
                    <b-col
                    cols="12"
                    sm="12"
                    lg="1"
                    class="d-flex align-items-center mb-1"
                    >
                    <span>Specialties: </span>
                    </b-col>
                    <b-col cols="12" sm="12" lg="3">
                    <span
                        class="phairify-select-wrapper w-100"
                        :class="[{ disabled: !isComparison }]"
                    >
                        <b-form-select
                        :options="specialtyOptions"
                        v-model="selectedSpecialtyId"
                        @change="changeSpecialty"
                        >
                        <template slot="first">
                            <option :value="null" disabled>
                            -- Select Specialty --
                            </option>
                        </template>
                        </b-form-select>
                    </span>
                    </b-col>
                </b-row>

                <!-- Subspecialty Filter -->
                <b-row class="mt-3" v-if="this.subSpecialtyOptions.length > 0">
                    <b-col
                    cols="12"
                    sm="12"
                    lg="1"
                    class="d-flex align-items-center mb-1"
                    >
                    <span>Subspecialty: </span>
                    </b-col>
                    <b-col cols="12" sm="12" lg="3">
                    <span class="phairify-select-wrapper w-100">
                        <b-form-select
                        :disabled="!selectedSpecialtyId"
                        :options="subSpecialtyOptions"
                        v-model="selectedSubSpecialtyId"
                        @change="refreshResults"
                        >
                        <template slot="first">
                            <option :value="null" disabled>
                            -- Select Subspecialty --
                            </option>
                        </template>
                        </b-form-select>
                    </span>
                    </b-col>
                </b-row>

                <!-- Questionnaire Filter -->
                <!-- <b-row class="mt-3" v-if="this.questionnaireOptions.length > 0">
                    <b-col
                    cols="12"
                    sm="12"
                    lg="1"
                    class="d-flex align-items-center mb-1"
                    >
                    <span>Questionnaire: </span>
                    </b-col>
                    <b-col cols="12" sm="12" lg="3">
                    <span class="phairify-select-wrapper w-100">
                        <b-form-select
                        :disabled="!selectedSpecialty"
                        :options="questionnaireOptions"
                        v-model="selectedQuestionnaireId"
                        >
                        <template slot="first">
                            <option :value="null" disabled>
                            {{
                                !selectedSpecialty
                                ? '-- Select Specialty --'
                                : '-- Select Questionnaire --'
                            }}
                            </option>
                        </template>
                        </b-form-select>
                    </span>
                    </b-col>
                </b-row> -->
            </div>
        </div>
        <!---- Filters End --->

        <b-card no-body class="v3_box_teal mt-4">          

          <div class="v3_box_teal_body p-4 mobile-responsive-box-body-padding">
            <div class="box-body-color-padding" v-if="this.specialties.length > 0">
              <!-- <b-row v-if="!questionnaire">
                <b-col
                  cols="12"
                  class="mt-3 d-flex justify-content-center align-items-center ml-2"
                >
                  <p class="v2_font_size_18">
                    There are no studies to view data for. Please check back later
                    or view your available studies.
                  </p>
                </b-col>
              </b-row> -->
              <b-row>
                <!-- Filters column -->
                <b-col md="6" lg="4" class="mb-5">
                  <div :class="[{ 'p-2 border_1 border_grey': this.selectedSpecialtyId }]">
                    <!-- comparisons -->
                    <v-wait :for="`${$options.name}_loading`">
                      <template slot="waiting">
                        <HalfCircleSpinner />
                        <div class="spinner-message my-3 text-center">
                          Checking reports data...
                        </div>
                      </template>
                      <template>
                        <div
                          :class="[{ 'with-instruction': isComparisonEmpty }]"
                        >
                          <h2
                            v-if="isComparisonEmpty && isUser"
                            class="instruction d-flex flex-column align-items-start" style="min-height: 400px"
                          >
                            <div class="d-flex align-items-center">
                              <span>
                                STEP 1 - Create a New report or Select a saved
                                report [disabled in sample version].
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <span>
                                STEP 2 - Select the Data Source you would like
                                to view for your report [fixed in sample
                                version]
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <span>
                                STEP 3 - Add Measures to view customized results
                                for your report [only some measures are
                                available in sample version].
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <span>
                                STEP 4 - Set Filters to fine tune the data
                                displayed for the measures.
                              </span>
                            </div>
                          </h2>
                          <h2
                          v-if="isComparisonEmpty && !isUser && !numberOfSelectedQuestions"
                            class="instruction d-flex flex-column align-items-start" style="min-height: 400px"
                          >
                            <div class="d-flex align-items-center">
                              <span>
                                STEP 1 - Select the applicable Specialty and Subspecialty. (Note: Inform is available for any specialty in which you have purchased and posted a job opportunity.)
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <span>
                                STEP 2 - Select a Measure - the aggregate data you want to analyze (e.g., total compensation, wRVUs, or years of practice).
                              </span>
                            </div>
                            <div class="mt-5 pt-1 d-flex align-items-center">
                              <span>
                                STEP 3 - Apply Filters to create personalized reports. For example, explore compensation ranges for specific locations and/or practice types. Inform displays the 25th, 75th, and median figures for any selected cohort.
                              </span>
                            </div>
                          </h2>
                        </div>
                        <!-- <b-row>
                          <b-col
                            cols="12"
                            class="d-flex align-items-center justify-content-between pr-0"
                          >
                            <div class="">Select Report:</div>
                            <div class="pl-1 d-flex align-items-center">
                              <span id="new-report-btn">
                                <b-button
                                  variant="v3_teal_rounded"
                                  class="ml-2"
                                  @click="newComparison"
                                >
                                  New
                                </b-button>
                                <b-tooltip
                                  target="new-report-btn"
                                  triggers="hover"
                                >
                                  The New feature is disabled in the sample
                                  version of Reports. Phairify members can
                                  create and customize as many reports as they
                                  like.
                                </b-tooltip>
                              </span>
                              <b-button
                                variant="v3_teal_rounded"
                                class="ml-2 mobile-select-margin"
                                @click="showSelectComparisonModal = true"
                                :disabled="comparisonOptions.length <= 1"
                              >
                                Select
                              </b-button>
                              <span class="mt-1">
                                <b-dropdown
                                  variant="dots"
                                  no-caret
                                  right
                                  menu-class="border_0 shadow-lg"
                                >
                                  <template slot="button-content">
                                    <div class="d-flex align-items-center">
                                      <i
                                        v-b-tooltip.hover
                                        title="Select actions for Reports"
                                        class="mdi mdi-dots-vertical phairify-icon-size-36 ml-n2"
                                      />
                                    </div>
                                  </template>
                                  <span id="rename-dropdown-item">
                                    <b-dropdown-item
                                      @click="onEditComparison"
                                      :disabled="!isComparison"
                                      class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray"
                                    >
                                      Rename
                                    </b-dropdown-item>
                                    <b-tooltip
                                      target="rename-dropdown-item"
                                      triggers="hover"
                                      placement="lefttop"
                                    >
                                      The Rename feature is disabled in the
                                      sample version of Reports
                                    </b-tooltip>
                                  </span>
                                  <span id="copy-dropdown-item">
                                    <b-dropdown-item
                                      @click="cloneComparison"
                                      :disabled="!isComparison"
                                      class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray"
                                    >
                                      Copy
                                    </b-dropdown-item>
                                    <b-tooltip
                                      target="copy-dropdown-item"
                                      triggers="hover"
                                      placement="lefttop"
                                    >
                                      The Copy feature is disabled in the sample
                                      version of Reports
                                    </b-tooltip>
                                  </span>
                                  <span id="delete-dropdown-item">
                                    <b-dropdown-item
                                      @click="onDeleteComparison"
                                      :disabled="!isComparison"
                                      class="d-flex align-items-center min_height_50 border_top_1 border_top_light_gray v2_color_red"
                                    >
                                      Delete
                                    </b-dropdown-item>

                                    <b-tooltip
                                      target="delete-dropdown-item"
                                      triggers="hover"
                                      placement="lefttop"
                                    >
                                      The Delete feature is disabled in the
                                      sample version of Reports
                                    </b-tooltip>
                                  </span>
                                </b-dropdown>
                              </span>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-4">
                          <b-col
                            cols="12"
                            sm="12"
                            lg="4"
                            class="d-flex align-items-center mb-1"
                          >
                            <span>Specialties: </span>
                          </b-col>
                          <b-col cols="12" sm="12" lg="8">
                            <span
                              class="phairify-select-wrapper w-100"
                              :class="[{ disabled: !isComparison }]"
                            >
                              <b-form-select
                                :options="specialtyOptions"
                                v-model="selectedSpecialtyId"
                                @change="refreshResults"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>
                                    -- Select Specialty --
                                  </option>
                                </template>
                              </b-form-select>
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col
                            cols="12"
                            sm="12"
                            lg="4"
                            class="d-flex align-items-center mb-1"
                          >
                            <span>Subspecialty: </span>
                          </b-col>
                          <b-col cols="12" sm="12" lg="8">
                            <span class="phairify-select-wrapper w-100">
                              <b-form-select
                                :disabled="!selectedSpecialtyId"
                                :options="subSpecialtyOptions"
                                v-model="selectedSubSpecialtyId"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>
                                    -- Select Subspecialty --
                                  </option>
                                </template>
                              </b-form-select>
                            </span>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col
                            cols="12"
                            sm="12"
                            lg="4"
                            class="d-flex align-items-center mb-1"
                          >
                            <span>Questionnaire: </span>
                          </b-col>
                          <b-col cols="12" sm="12" lg="8">
                            <span class="phairify-select-wrapper w-100">
                              <b-form-select
                                :disabled="!selectedSpecialty"
                                :options="questionnaireOptions"
                                v-model="selectedQuestionnaireId"
                              >
                                <template slot="first">
                                  <option :value="null" disabled>
                                    {{
                                      !selectedSpecialty
                                        ? '-- Select Specialty --'
                                        : '-- Select Questionnaire --'
                                    }}
                                  </option>
                                </template>
                              </b-form-select>
                            </span>
                          </b-col>
                        </b-row> -->
                        <!-- Measures -->
                        <b-row v-if="this.selectedSpecialtyId">
                          <b-col>
                            <div class="">
                              <b-row class="align-items-center">
                                <b-col class="text-nowrap mb-2 text-left">
                                  <span class="">
                                    Select Measures
                                    <span v-if="numberOfSelectedQuestions">
                                      ({{ numberOfSelectedQuestions }})
                                    </span>
                                  </span>
                                </b-col>
                                <!-- TODO: refresh on load to show any new questions -->
                                <b-col class="text-center">
                                  <ChartsPicker
                                    v-if="this.showData"
                                    button-class="w-100"
                                    items-name="Measures"
                                    ref-id="add-question"
                                    :questionnaire="this.questionnaire ? this.questionnaire : {}"
                                    :ids="comparison ? comparison.charts : {}"
                                    :favorites="favorites"
                                    @selected="onChartsSelected"
                                    :is-disabled="!isComparison"
                                    :tooltip-text="`Choose measures to display in the report`"
                                    :apply-tooltip-text="`Apply selections to the report`"
                                  />
                                </b-col>
                              </b-row>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col v-if="!isComparisonEmpty">
                            <SurveySelectedCharts
                              :questions="questions"
                              :questionnaire="questionnaire ? questionnaire : {}"
                              :comparison="comparison"
                              :results-sorted="resultsSorted"
                              :tooltip-title="`Remove this measure from the report`"
                              :is-profile-visible="
                                questionnaire ? !!questionnaire.supports_profile_measures : false
                              "
                              @remove-question="removeQuestionFromCharts"
                              @remove-der-var="removeDerVar"
                            />
                            <!-- filters -->
                            <div
                              :class="[
                                { 'with-instructions': isComparisonEmpty },
                              ]"
                            >
                              <!-- Select filters UI  -->
                              <filters-selector
                                ref="filtersSelector"
                                :key="'all'"
                                :questionnaire="this.questionnaire ? this.questionnaire : {}"
                                :initial-filters="
                                  comparison ? comparison.filters : {}
                                "
                                :initial-filter-values="
                                  comparison ? comparison.filterValues : {}
                                "
                                :is-specialty-filter-visible="false"
                                @filters-apply="onFiltersApply"
                                @set-tags="variableTags = $event"
                              />
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </v-wait>
                  </div>
                </b-col>
                <!-- Results column -->
                <b-col md="6" lg="8" class="py-0">
                  <div class="flex-md-row">
                    <div>
                      <survey-result-tags
                        :key="(comparison || {}).title"
                        :tags="variableTags"
                        @remove-tag="onRemoveTag"
                        @clear-all="onTagClearAll"
                      />
                    </div>
                  </div>

                  <v-wait :for="`${$options.name}_loading`">
                    <template slot="waiting">
                      <HalfCircleSpinner />
                      <div class="spinner-message my-3 text-center">
                        Checking reports data...
                      </div>
                    </template>
                    <template>
                      <div
                        v-for="(res, index) in resultsSorted"
                        :key="res.id || index"
                      >
                        <b-card
                          no-body
                          class="mx-auto h-100 rounded-0 border_1 border_grey v3_bg_transparent mb-2"
                          v-if="preloadQuestion(index)"
                        >
                          <b-card-header v-if="res && res.chart_title">
                            <b-row>
                              <b-col
                                cols="10"
                                class="d-flex align-items-center"
                              >
                                <h2
                                  class="survey-results__question-prompt phairify-color-navy mb-0"
                                >
                                  <strong>
                                    {{ res.chart_title }}
                                  </strong>
                                </h2>
                              </b-col>
                              <b-col cols="2" class="text-right">
                                <i
                                  v-if="res.question"
                                  class="mdi mdi-help-circle-outline phairify-color-navy"
                                  aria-hidden="true"
                                  :id="`chart_question_tooltip_${res.id}`"
                                  @mouseover="onTooltipMouseOver(index)"
                                  @mouseout="onTooltipMouseOut(index)"
                                />
                              </b-col>
                            </b-row>

                            <b-tooltip
                              v-if="res.question"
                              ref="chart_question_tooltips"
                              :target="`chart_question_tooltip_${res.id}`"
                              placement="left"
                            >
                              {{ res.question.prompt }}
                            </b-tooltip>
                          </b-card-header>
                          <b-card-body>
                            <div v-if="res && res.insufficient">
                              <b-alert show variant="warning">
                                There is not enough data to display.
                              </b-alert>
                            </div>
                            <div
                              v-else-if="
                                res && res.results && !res.results.length
                              "
                            >
                              <b-alert show variant="warning">
                                No results found.
                              </b-alert>
                            </div>
                            <div v-else-if="res">
                              <ChartBuilder
                                :result="res"
                                :format="chartFormat"
                                :comparison="comparison"
                                :is-title-visible="false"
                                :is-border-visible="false"
                              />
                            </div>
                          </b-card-body>
                        </b-card>
                      </div>
                    </template>
                  </v-wait>
                </b-col>
              </b-row>
            </div>
            <!-- <div v-else-if="!questionnaire">
              <b-row>
              <b-col
                cols="12"
                class="mt-3 d-flex justify-content-center align-items-center ml-2"
              >
                <p class="v2_font_size_18">
                  There are no studies to view data for. Please check back later
                  or view your available studies.
                  There are no studies to view data for. Please check back later
                  or view your available studies.
                  There are no studies to view data for. Please check back later
                  or view your available studies.
                </p>
              </b-col>
            </b-row>
            </div> -->
            <div
              class="survey-results__loading-indicator width_400"
              v-if="this.preloading"
            >
              <b-alert
                show
                variant="warning"
                class="d-flex justify-content-left align-items-center py-2"
              >
                <HalfCircleSpinner class="v2" />
                <span
                  v-if="variableTags && Object.keys(variableTags).length !== 0"
                >
                  Applying filters…
                </span>
                <template v-else>
                  <span>Loading</span>
                  &ensp;
                  <span v-if="questionnaireLoading">study ...</span>
                  <span v-else>charts ...</span>
                </template>
              </b-alert>
            </div>

            <reports-placeholder-image
              v-else-if="isQuestionnaireNotSupportsReports && !preloading"
              :questionnaire-report-image="
                questionnaire ? questionnaire.report_image : null
              "
            />
            <b-row v-else-if="!questionnaire && !preloading && isUser">
              <b-col
                cols="12"
                class="mt-3 d-flex justify-content-center align-items-center ml-2"
              >
                <p class="v2_font_size_18">
                  There are no studies to view data for. Please check back later
                  or view your available studies.
                </p>
              </b-col>
            </b-row>
            <!-- <b-row v-if="this.specialties.length == 0" class="text-center">
              <p class="v2_font_size_18">
                You need to purchase a Job Opportunity before you can use inform.
              </p>
            </b-row> -->
          </div>
        </b-card>
      </div>
      <div v-else-if="!this.showData" class="mobile-responsive-padding-box">
        <b-card class="v3_box_teal mt-4">
          <b-row v-if="this.specialties.length == 0" class="text-center">
            <b-col md="12" lg="12" class="mb-5">
              <p class="v2_font_size_18">
                You need to purchase a Job Opportunity before you can use inform.
              </p>
              </b-col>
          </b-row>
        </b-card>
        </div>
    </div>

    <create-comparison-modal
      v-if="showNewComparisonModal"
      :initial-title="(editedComparison || {}).title"
      :is-edit-type="!!editedComparison"
      :comparison-titles="comparisonTitles"
      @modalSave="onModalSave"
      @modalCancel="onCancelComparison"
    />

    <!-- access modal -->

    <b-modal
      :visible="showSelectComparisonModal"
      title="Select Report"
      ok-only
      @hide="showSelectComparisonModal = false"
    >
      <b-form-select
        v-model="comparison"
        :options="comparisonOptions"
        :disabled="!isComparison"
      />
    </b-modal>

    <!-- access modal -->

    <b-modal
      id="no-access-modal"
      ref="noAccessModal"
      :hide-footer="true"
      title="Access Restricted"
    >
      Please go away!
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Api, { didAbort } from '@/providers/Api.js';
import { HalfCircleSpinner } from 'epic-spinners';
import SurveySelectedCharts from '@/components/survey/SurveySelectedCharts';
import ChartsPicker from '@/components/survey/results/ChartsPicker';
import DerivedVariables from '@/providers/DerivedVariables';
import Questionnaire from '@/providers/Questionnaire.js';
import flatten from 'lodash/flatten';
import keyBy from 'lodash/keyBy';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import UserSettings from '@/providers/UserSettings';
import CreateComparisonModal from '@/components/comparison/CreateModal';
import {
  COOKIES,
  REPORTS_SCOPE_TYPES,
  SET_PRIMARY_QUESTIONNAIRE_COMPARISONS_MUTATION,
  SETTINGS_KEYS,
} from '@/store';
import Help from '@/providers/Help';
import ChartBuilder from '@/components/survey/results/ChartBuilder';
import ReportsPlaceholderImage from '@/components/survey/results/ReportsPlaceholderImage';
import FiltersSelector from '@/components/survey/results/select-filters/SelectFilters';
import PdfReportsMixin from '@/mixins/PdfReportsMixin';
import SurveyResultTags from '@/components/survey/results/SurveyResultTags';
import QuestionnaireProvider from '@/providers/Questionnaire.js';

const putDataToFilters = (comparison, questions = [], derVars = []) => ({
  comparison: {
    ...comparison,
    charts: {
      ...comparison.charts,
      derivedVarNames: derVars,
      questionIds: questions,
    },
  },
});

const reportsQuestionsAsComparisonFactory =
  (filterCallback) =>
  (questionnaire, sectionId = null) => {
    let comparison = cloneDeep(UserSettings.defaultResultCharts);
    let sections = (questionnaire || {}).sections;
    if (sectionId) {
      sections = sections.filter((s) => s.id === sectionId);
    }
    const questions = flatten(
      (sections || []).map((section) => {
        if (!section || !section.questionSections) return [];
        return section.questionSections
          .filter(filterCallback)
          .map((qs) => qs.question);
      })
    );
    const [questionIds, variableIds] = questions.reduce(
      ([qIds, vIds], question) => {
        qIds.push(question.id);
        vIds = vIds.concat(question.variables.map(({ id }) => id));
        return [qIds, vIds];
      },
      [[], []]
    );
    comparison.charts.questionIds = questionIds;
    comparison.charts.variableIds = variableIds;
    return comparison;
  };

const getDisplayOnReportsQuestionsAsComparison =
  reportsQuestionsAsComparisonFactory(
    (qs) =>
      qs.question && qs.is_default_on_results && qs.is_available_on_results
  );

export default {
  name: 'RecruiterInform',
  mixins: [PdfReportsMixin],
  components: {
    SurveySelectedCharts,
    ChartsPicker,
    CreateComparisonModal,
    HalfCircleSpinner,
    ReportsPlaceholderImage,
    ChartBuilder,
    FiltersSelector,
    SurveyResultTags,
  },
  props: {
    title: String,
  },
  data: function () {
    return {
      route: this.$route.path,
      format: 'filters',
      preloading: false,
      // need to create a copy of these so we can bind the 'expanded' var to each (??)
      dvVariables: DerivedVariables.userFilterVariables,
      results: {},
      editedComparison: null,
      comparisonSettings: cloneDeep(UserSettings.defaultComparisons),
      isOptionsHidden: false,
      variableTags: null,
      scopeOptions: [],
      scope: REPORTS_SCOPE_TYPES.SPECIALTY,
      showNewComparisonModal: false,
      showSelectComparisonModal: false,
      takeStudyLoading: false,
      specialties: [],
      subSpecialties: [],
      selectedSpecialtyId: null,
      selectedSubSpecialtyId: null,
      jobQuestions: [],
      questionnaireLoading: false,
      selectedQuestionnaireId: null,
      showData:true,
    };
  },
  created: function () {
    this.getPaidSpecialties();
    if (!this.comparisonSettings || !this.questionnaire) {
      this.getComparisonSettings();
    }
    //this.refreshResults();
  },
  mounted: function () {
    if (this.$cookies.isKey(COOKIES.RECRUITER.INFORM.SPECIALTY_ID)) {
      this.selectedSpecialtyId = parseInt(
        this.$cookies.get(COOKIES.RECRUITER.INFORM.SPECIALTY_ID)
      );
    }
    if (this.$cookies.isKey(COOKIES.RECRUITER.INFORM.SUBSPECIALTY_ID)) {
      this.selectedSubSpecialtyId = parseInt(
        this.$cookies.get(COOKIES.RECRUITER.INFORM.SUBSPECIALTY_ID)
      );
    }
    if (this.$cookies.isKey(COOKIES.RECRUITER.INFORM.QUESTIONNAIRE_ID)) {
      this.selectedQuestionnaireId = parseInt(
        this.$cookies.get(COOKIES.RECRUITER.INFORM.QUESTIONNAIRE_ID)
      );
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    isUser: function() {
     return this.$store.getters.userIsMSSUser ? true : false;
    },
    isComparisonEmpty: function () {
      return (
        !this.comparison ||
        (!this.comparison.charts.questionIds.length &&
          !this.comparison.charts.derivedVarNames.length)
      );
    },
    isComparison: function () {
      return !!this.comparison;
    },
    comparisons: {
      get: function () {
        const settings = this.comparisonSettings;
        return settings && settings.comparisons
          ? settings.comparisons
          : UserSettings.defaultComparisons;
      },
      set: function (comparisons) {
        this.$set(this.comparisonSettings, 'comparisons', comparisons);
      },
    },
    comparison: {
      get: function () {
        if (!this.comparisons || !this.comparisons.length) {
          return null;
        }
        // otherwise show the selected one (this gets overridden on the Results
        // page, so only applies to the Compare page)
        let selectedComparison = this.comparisons
          ? this.comparisons.find((c) => c.selected)
          : [];
        if (!selectedComparison) {
          selectedComparison = this.comparisons[0];
        }
        return selectedComparison;
      },
      set: function (comparison) {
        const { comparisons } = this.comparisonSettings || {};
        (comparisons || []).forEach((c) => {
          c.selected = Object.is(c, comparison);
        });
      },
    },
    comparisonTitle: {
      get: function () {
        return this.comparison ? this.comparison.title : null;
      },
      set: function (val) {
        this.comparison.title = val;
      },
    },
    comparisonOptions: function () {
      return (
        (this.comparisonSettings && this.comparisonSettings.comparisons) ||
        []
      ).map((s) => {
        return { value: s, text: s.title };
      });
    },
    questions: function () {
      if (!this.questionnaire) {
        return [];
      }
      const qs = flatten(
        this.questionnaire.sections.map((section) => {
          if (!section || !section.questionSections) return [];
          return section.questionSections
            .filter(
              (qs) =>
                !!qs.question &&
                (this.format !== 'filters' || qs.is_available_on_results)
            )
            .map((qs) => qs.question);
        })
      );
      return keyBy(qs, (q) => q.id);
    },
    variables: function () {
      if (!this.questionnaire) {
        return [];
      }
      const vs = flatten(
        Object.values(this.questions).map((question) => {
          return question.variables;
        })
      );
      return keyBy(vs, (v) => v.id);
    },
    // if we're in filter mode, sort the results in the order of this.questionIds,
    // rather than the default order by question ID as returned from the API
    resultsSorted: function () {
      let results = Array.isArray(this.results) ? this.results : [];
      if (this.comparison) {
        const sections = (this.questionnaire || {}).sections || [];
        const selectedQsIds = (this.comparison.charts || {}).questionIds || [];
        const selectedVIds = (this.comparison.charts || {}).variableIds || [];
        const filter = QuestionnaireProvider.getQuestionnaireSections(
            sections,
            selectedQsIds,
            selectedVIds
          );

        const mergedQuestions = filter.reduce((accumulator, currentValue) => {
          return accumulator.concat(currentValue.questions);
        }, []);
        // const baseArray = (filter[0] && filter[0].questions) || [];
        const baseArray = mergedQuestions;
        //const resultIndexMap = new Map(results.map((item, index) => [item.id, index]));
        results.sort((a, b) => {
            if (a.id === "userSpecialtyId") return -1;
            if (b.id === "userSpecialtyId") return 1;

            // const indexA = resultIndexMap.get(a.id);
            // const indexB = resultIndexMap.get(b.id);
            return baseArray.findIndex(item => item.question.id === a.id) - baseArray.findIndex(item => item.question.id === b.id);
        });
        // console.log(results,"results");
        // results = results.filter((res) => {
        //   return (
        //     this.comparison.charts.questionIds.includes(res.id) ||
        //     this.comparison.charts.derivedVarNames.includes(res.id)
        //   );
        // });
      }
      // todo: add ordering here when will be implemented
      return results.filter((r) => !!r && !!r.id);
    },
    pageTitle: function () {
      return `${(this.questionnaire || {}).period || ''} ${
        (this.questionnaire || {}).title || ''
      }`;
    },
    comparisonTitles: function () {
      return this.comparisons ? this.comparisons.map((c) => c.title) : [];
    },
    comparisonLimit: function () {
      const limit = this.$store.state.settings.comparison_limit || 10;
      return parseInt(limit);
    },
    favorites: function () {
      return this.questionnaire && this.questionnaire.favorites
        ? JSON.parse(this.questionnaire.favorites)
        : null;
    },
    isQuestionnaireNotSupportsReports: function () {
      return (
        this.questionnaire &&
        this.format === 'filters' &&
        parseInt(this.questionnaire.is_support_report) === 0
      );
    },
    questionnaireStartDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.start_date).format('MMM D, YYYY')
        : '';
    },
    questionnaireClosedDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.end_date).format('MMM D, YYYY')
        : '';
    },
    numberOfSelectedQuestions: function () {
      if (!this.comparison || !this.questions) {
        return [];
      }
      const questionIds = (this.comparison.charts || {}).questionIds || [];
      return Object.values(this.questions).filter(({ id }) =>
        questionIds.includes(id)
      ).length;
    },
    chartFormat: function () {
      return this.format;
    },
    sampleReportLink: function () {
      const storePath = this.$store.getters.getSetting(
        SETTINGS_KEYS.ASSETS_STORE_URL
      );
      return storePath ? `${storePath}/SampleReport.pdf` : '#';
    },
    specialtyOptions: function () {
      const options = [];
      (this.specialties || []).forEach((s) => {
        options.push({ value: s.id, text: s.title });
      });
      return options;
    },
    selectedSpecialty: function () {
      return this.specialties.find((s) => s.id === this.selectedSpecialtyId);
    },
    subSpecialtyOptions: function () {
      const options = [];
      (this.subSpecialties || [])
        .filter((ss) => {
          return (
            !this.selectedSpecialty ||
            this.selectedSpecialty.id === ss.specialty_id
          );
        })
        .forEach((ss) => {
          options.push({ value: ss.id, text: ss.title });
        });
      return options;
    },
    selectedSubSpecialty: function () {
      return this.subSpecialties.find(
        (s) => s.id === this.selectedSubSpecialtyId
      );
    },
    questionnaireOptions: function () {
      return ((this.selectedSpecialty || {}).questionnaires || []).map((q) => {
        return { value: q.id, text: q.title };
      });
    },
    questionnaire: function () {
      // return ((this.selectedSpecialty || {}).questionnaires || []).find(
      //   (q) => q.id === selectedQuestionnaireId
      // );
      if(this.selectedQuestionnaireId)
      {
        return ((this.selectedSpecialty || {}).questionnaires || []).find(
          (q) => q.id === this.selectedQuestionnaireId
        );
      }else{
        return null;
      }
    },
  },
  methods: {
    getPaidSpecialties: async function () {
      this.showData=true;
      this.preloading = true;
      try {
        const { specialties, subSpecialties } = await Api.getPaidSpecialties();
        this.$set(this, 'specialties', specialties);
        this.$set(this, 'subSpecialties', subSpecialties);
        this.refreshResults();
        if(this.specialties.length == 0)
        {
          this.showData=false;
        }
      } catch (e) {
        if (!didAbort(e)) throw e;
      } finally {
        this.preloading = false;
      }
    },
    preloadQuestion: function (index) {
      return !this.preloading || index < 4;
    },
    cloneComparison: function () {
      if (this.comparisons.length >= this.comparisonLimit) {
        this.$toasted.info(
          `Only ${this.comparisonLimit} reports are allowed. You can delete an existing report and try again.`,
          {
            duration: 3000,
          }
        );
        return;
      }
      if (!this.comparison) {
        this.$toasted.info('There is no Report to be cloned.', {
          duration: 3000,
        });
        return;
      }
      const newComparison = cloneDeep(this.comparison);
      newComparison.title = 'Copy of ' + newComparison.title;
      this.comparisons.push(newComparison);
      this.comparison = newComparison;
    },
    newComparison: function () {
      if (this.comparisons.length >= this.comparisonLimit) {
        this.$toasted.info(
          `Only ${this.comparisonLimit} reports are allowed. You can delete an existing report and try again.`,
          {
            duration: 3000,
          }
        );
        return;
      }
      this.editedComparison = null;
      this.showNewComparisonModal = true;
    },
    onEditComparison: function () {
      this.editedComparison = this.comparison;
      this.showNewComparisonModal = true;
    },
    onModalSave: function (newTitle) {
      const index = this.comparisons.findIndex(
        (c) => c.title === (this.editedComparison || {}).title
      );

      let message = 'Reports saved successfully.';

      if (index !== -1) {
        this.$set(this.comparisons[index], 'title', newTitle);
      } else {
        const newComparison = cloneDeep(
          UserSettings.defaultComparisons[0] || {}
        );
        newComparison.title = newTitle;
        this.$set(this.comparisons, this.comparisons.length, newComparison);

        this.comparison = newComparison;

        message = 'Reports created successfully.';
      }

      this.saveComparison();

      this.editedComparison = null;

      this.showNewComparisonModal = false;

      this.$toasted.success(message, {
        duration: 3000,
      });
    },
    onCancelComparison: function () {
      this.editedComparison = null;
      this.showNewComparisonModal = false;
    },
    onDeleteComparison: function () {
      if (this.comparisons.length === 1) {
        this.$toasted.error(
          'Delete not allowed, at least one report must be active.',
          {
            duration: 6000,
            action: {
              icon: 'mdi mdi-close-circle toaster-close-icon',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
        return;
      }
      Help.confirm.show(
        `Are you sure you want to delete the '${this.comparison.title}' report?`,
        'Yes',
        () => {
          this.deleteComparison();
        }
      );
    },
    deleteComparison: function () {
      this.comparisons = (this.comparisons || []).filter(
        (comp) => !comp.selected
      );
      this.comparison = this.comparisons[0];
      this.saveComparison();
      this.$toasted.success('Report deleted successfully.', {
        duration: 3000,
      });
    },
    removeDerVar: function (derVar) {
      this.$delete(
        this.comparison.charts.derivedVarNames,
        this.comparison.charts.derivedVarNames.indexOf(derVar.id || derVar.name)
      );
      this.saveComparison();
      this.refreshResults();
    },
    removeQuestionFromCharts: function (questionToRemove) {
      const qid = (questionToRemove || {}).id;
      this.$delete(
        this.comparison.charts.questionIds,
        this.comparison.charts.questionIds.indexOf(qid)
      );
      // remove varIDs also
      const questionnaire = this.questionnaire || {};
      const question = Questionnaire.findQuestion(questionnaire, qid);
      (question.variables || []).forEach(({ id: vId = null }) => {
        this.$delete(
          this.comparison.charts.variableIds,
          this.comparison.charts.variableIds.indexOf(vId)
        );
      });
      // this.questionnaire = {...this.questionnaire};

      this.questionnaire = {...this.questionnaire};
      
      this.questionnaire = {...this.questionnaire};
      this.saveComparison();
      this.refreshResults();
    },
    onFiltersApply: function (filtersData) {
      const { filterValues, filters } = filtersData;
      this.$set(this.comparison, 'filterValues', filterValues);
      this.$set(this.comparison, 'filters', filters);
      this.$nextTick(() => {
        this.refreshResults();
        this.getVariableTags();
      });
    },
    questionnaireIds(questionnairs) {
      const ids = [];
      for (let i = 0; i < questionnairs.length; i++) {
        ids.push(questionnairs[i].id);
      }
      return questionnairs.map(questionnair => questionnair.id).join(', ');
    },
    refreshResults: async function () {
      this.results = [];
      if(this.selectedSpecialty)
      {
        const queIds = this.questionnaireIds(this.selectedSpecialty.questionnaires);
        const getLatestquestionnaireId =
        await Api.getRecruiterLatestSurveyResults(queIds);
        this.selectedQuestionnaireId = getLatestquestionnaireId;
        // this.selectedQuestionnaireId = this.selectedSpecialty.questionnaires[0].id;
        this.questionnaire;
      }

      if (!this.questionnaire) {
        return;
      }
      if (!this.comparisonSettings) {
        return;
      } 
      // else if (
      //   this.comparison &&
      //   this.comparison.charts &&
      //   (this.comparison.charts.questionIds.length > 2 ||
      //     this.comparison.charts.derivedVarNames.length > 2)
      // ) {
      //   this.sendTwoRequests();
      // }
       else {
        let filters = {
          comparison: this.comparison,
        };
        if(this.selectedSpecialtyId){
          this.$set(this.comparison, 'r_specialty', this.selectedSpecialtyId);
        }
        let selectedSubSpecialtyIdVal = this.$cookies.get(COOKIES.RECRUITER.INFORM.SUBSPECIALTY_ID)
        this.$set(this.comparison, 'r_subspecialty', parseInt(selectedSubSpecialtyIdVal));
        
        this.preloading = true;
        try {
          const { results } = await Api.getRecruiterSurveyResults(
            this,
            'getRecruiterSurveyResults',
            filters,
            (this.questionnaire || {}).id,
            this.scope
          );
          this.results = results;
        } catch (e) {
          if (!didAbort(e)) throw e;
        } finally {
          this.preloading = false;
        }
      }
      this.saveComparison();
    },

    // when we're showing one chart per variable on a question,
    // only give the chart a title if there is > 1 variable
    getVariableChartTitle: function (q, varLabel) {
      if (q && q.question && q.question.variablesCount === 1) {
        return '';
      } else {
        return varLabel;
      }
    },
    splitOnTwoRequests: function () {
      let firstFetched = false;
      const afterFetch = ({ results }) => {
        this.results = results;
        if (!firstFetched) {
          firstFetched = true;
          // this.results = results;
        } else {
          // this.results.push(...results);
          this.preloading = false;
        }
      };
      const catchError = (error) => {
        if (firstFetched) {
          this.preloading = false;
        } else {
          firstFetched = true;
        }
        if (didAbort(error)) return;
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.$toasted.error(error.response.data.message, { duration: 3000 });
        } else {
          this.$toasted.error(
            'Unable to load some data, please try again later',
            { duration: 3000 }
          );
        }
      };
      let firstReqFilters = null;
      let secondReqFilters = null;
      if (this.comparison.charts.questionIds.length > 2) {
        const [...restOfQuestions] =
          this.comparison.charts.questionIds;
        firstReqFilters = putDataToFilters(
          this.comparison,
          this.comparison.charts.questionIds,
          []
        );
        secondReqFilters = putDataToFilters(
          this.comparison,
          restOfQuestions,
          this.comparison.charts.derivedVarNames
        );
      } else {
        // const [firstDerVar, secondDerVar, ...restDerVars] =
        //   this.comparison.charts.derivedVarNames;
        firstReqFilters = putDataToFilters(
          this.comparison,
          [],
          this.comparison.charts.derivedVarNames
        );
        secondReqFilters = putDataToFilters(
          this.comparison,
          this.comparison.charts.questionIds,
          this.comparison.charts.derivedVarNames
        );
      }
      return {
        firstReqFilters,
        secondReqFilters,
        afterFetch,
        catchError,
      };
    },

    sendTwoRequests: function () {
      const { firstReqFilters, secondReqFilters, afterFetch, catchError } =
        this.splitOnTwoRequests();
      this.preloading = true;
      Api.getRecruiterSurveyResults(
        this,
        'getRecruiterSurveyResults',
        firstReqFilters,
        (this.questionnaire || {}).id,
        this.scope
      )
        .then(afterFetch)
        .catch(catchError);
      Api.getRecruiterSurveyResults(
        this,
        'getRecruiterSurveyResults',
        secondReqFilters,
        (this.questionnaire || {}).id,
        this.scope
      )
        .then(afterFetch)
        .catch(catchError);
    },

    getComparisonSettings: async function () {
      const qId = (this.questionnaire || {}).id;
      if (!qId) return;
      try {
        this.$wait.start(this.$options.name + '_loading');
        this.preloading = true;
        const comparisonSettingsData =
          await Api.getQuestionnaireComparisonSettings(qId);
        const { comparisons: comparisonsSettings, questionnaire } =
          comparisonSettingsData || {};
        let { comparisons } = comparisonsSettings || {};
        this.comparisonSettings = {
          comparisons: comparisons || [
            getDisplayOnReportsQuestionsAsComparison(questionnaire),
          ],
        };
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
        this.$toasted.error('Unable to upload data, please try again later', {
          duration: 3000,
        });
      } finally {
        this.$wait.end(this.$options.name + '_loading');
        this.preloading = false;
      }
    },
    saveComparison: debounce(async function () {
      const qId = (this.questionnaire || {}).id;
      try {
        await Api.updateQuestionnaireComparisons(
          qId,
          JSON.stringify(this.comparisonSettings)
        );
        this.$store.commit(
          SET_PRIMARY_QUESTIONNAIRE_COMPARISONS_MUTATION,
          this.comparisonSettings
        );
      } catch (e) {
        process.env.NODE_ENV !== 'production' && console.error(e);
      }
    }, 1000),
    onChartsSelected: function (comparisonCharts) {
      this.comparison.charts = comparisonCharts;
      this.refreshResults();
    },
    onTooltipMouseOver: function (i) {
      this.$refs.chart_question_tooltips[i].$emit('open');
    },
    onTooltipMouseOut: function (i) {
      this.$refs.chart_question_tooltips[i].$emit('close');
    },
    onClearAll: function () {
      const { filterValues, filters } = this.$refs.filtersSelector.getFilters();
      this.$set(this.comparison, 'filterValues', filterValues);
      this.$set(this.comparison, 'filters', filters);

      this.onFiltersApply();
    },
    onRemoveTag: function (removedTag) {
      this.$refs.filtersSelector.updateFiltersByTag(removedTag);
    },
    onTagClearAll: function () {
      if (
        this.$refs.filtersSelector &&
        typeof this.$refs.filtersSelector.onClearAll === 'function'
      ) {
        this.$refs.filtersSelector.onClearAll();
      }
    },
    getVariableTags: function () {
      if (
        !this.$refs.filtersSelector ||
        typeof this.$refs.filtersSelector.getTags !== 'function'
      ) {
        this.variableTags = null;
        console.info('filters block is not specified');
      } else {
        this.variableTags = this.$refs.filtersSelector.getTags();
      }
    },
    changeSpecialty: async function () {
       this.$cookies.remove(COOKIES.RECRUITER.INFORM.SUBSPECIALTY_ID);
       this.refreshResults();
    },
  },
  watch: {
    $route: function () {
      this.refreshResults();
    },
    selectedSpecialtyId: function (newVal) {
      this.$cookies.set(COOKIES.RECRUITER.INFORM.SPECIALTY_ID, newVal);
    },
    selectedSubSpecialtyId: function (newVal) {
      this.$cookies.set(COOKIES.RECRUITER.INFORM.SUBSPECIALTY_ID, newVal);
    },
    selectedQuestionnaireId: function (newVal) {
      this.$cookies.set(COOKIES.RECRUITER.INFORM.QUESTIONNAIRE_ID, newVal);
    },
    comparison: {
  immediate: true,
  deep: true,
  handler() {
    // refresh results on first load, but not in response to filter changes
    // (for those, must click Apply button)
    this.refreshResults();
    this.$nextTick(() => {
      this.getVariableTags();
    });
  }
},
    questionnaire: function () {
      this.getComparisonSettings();
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->
<style scoped>
.box-body-color-padding {
  background-color: rgba(2, 22, 35, 0.025);
  padding: 2rem;
  min-height: 400px;
}

@media (min-width: 320px) and (max-width: 768px) {
  .mobile-responsive-heading {
    text-align: center !important;
  }

  .mobile-responsive-padding-box {
    padding: 0 15px !important;
  }

  .mobile-responsive-box-body-padding {
    padding: 10px !important;
  }
  .box-body-color-padding {
    padding: 0.7rem !important;
  }
  .mobile-header-content-center {
    text-align: center !important;
  }
}
</style>
<style lang="scss">
@import '../../../../sass/variables_mixins.scss';
@import '../../../../sass/v3.scss';

.survey-results__loading-indicator {
  position: fixed;
  bottom: 75px;
  left: 50%;
  transform: translateX(-50%);
  @media (max-width: 768px) {
    width: 100%;
  }

  .alert.alert-warning {
    color: inherit;
    font-weight: bold;
    background-color: #beccd541;
    border-color: $phairify_primary_border_color;
  }

  .survey-results__loading-indicator__icon-wrapper {
    display: inline-block;
    position: relative;
    width: $phairify_icon-size_large;
    height: $phairify_icon-size_large;

    .material-design-icon {
      position: absolute;
      top: 3px;
    }
  }
}

.survey-results .highcharts-container {
  margin: auto;
}

.survey-results__question-prompt {
  width: calc(100% - 30px);
  @include phairify_heading_not_bold_18;
}

.survey-results__question-id {
  position: absolute;
  bottom: 5px;
  left: 10px;
  color: #bbb;
}

.survey-results__button {
  svg.icon {
    fill: #fff !important;
    width: 12px;
    height: 12px;
  }
}

.survey-results__apply-button {
  font-weight: bold;

  svg.icon {
    fill: #fff !important;
    margin-left: 5px;
  }
}

.survey-results {
  min-width: 360px;
  margin-top:0px !important;

  .width_107 {
    width: 107px;
  }

  .survey-results__title {
    @include phairify_heading_bold_18;
  }

  .survey-results__menus_wrapper {
    flex: 0 0 430px;
    @media (max-width: 1200px) and (min-width: 768px) {
      flex: 0 0 320px;
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .survey-results__charts-wrapper {
    flex: 1 1 auto;
  }

  .survey-results__card_title {
    @include phairify_heading_bold_18;
    color: $phairify_primary_color_navy;
  }

  .survey-results__content {
    .survey-results__menu-card {
      @include phairify_card_with_padding;
      min-height: calc(100vh - 200px);
    }
  }

  .survey-results__edit-comparison-btn {
    line-height: 32px;
  }

  .alert {
    i.mdi {
      color: inherit;
    }
  }

  .material-design-icon {
    height: $phairify_icon-size_large;
    width: $phairify_icon-size_large;
  }

  .material-design-icon > .material-design-icon__svg {
    height: $phairify_icon-size_large;
    width: $phairify_icon-size_large;
    fill: $phairify_primary_color_icon;
  }

  .survey-results__poll-icon {
    margin-right: 0;
  }

  .survey-results__icon-wrapper {
    @media (min-width: 576px) {
      margin-right: 5px;
    }

    i.mdi {
      line-height: 15px;
    }

    i.mdi:before {
      position: relative;
      top: 3px;
    }
  }

  .survey-results__selected-chart {
    padding-bottom: 0;
    @include phairify_body_copy;

    label {
      font-weight: normal;
    }
  }

  .btn.btn-secondary {
    @include phairify_white_button;
  }

  .btn.btn-danger {
    @include phairify_danger_button;
  }

  .survey-results__empty-info-wrapper,
  .survey-results__create-comparison-info-wrapper {
    height: 51px;

    .survey-results__empty-info-text {
      display: inline-flex;
      align-items: center;
      font-size: 14px;
      height: 36px;
      vertical-align: middle;
      color: rgba($phairify_primary_color_icon, 0.5);

      i.mdi {
        font-size: 36px;
        color: rgba($phairify_primary_color_icon, 0.5);
      }
    }

    @media (max-width: 768px) {
      i.mdi {
        display: none;
      }
    }

    &.with-margin {
      @media (min-width: 721px) {
        margin-top: 188px;
      }
    }
  }

  .survey-results--modal-dialog {
    max-width: 425px;
    @media (max-width: 575px) {
      max-width: 360px;
    }
  }

  .survey-results--filter-buttons {
    .btn.btn-filter {
      @include phairify_body_copy;
      border: none;
      border-radius: 0;
      background-color: $phairify_primary_border_color;
      color: $phairify_secondary_color_grey;

      &.active {
        background-color: rgba($phairify_secondary_color_lime, 0.25);
        color: #000000;
      }
    }
  }

  .survey-results__input-label {
    @include phairify_body_copy;
    font-weight: bold;
    color: $phairify_primary_color_teal;
  }

  .min-width-142-px {
    min-width: 142px !important;
  }

  .with-instructions{
    position: relative;
  }

  .with-instruction {
    position: relative;

    .instruction {
      position: absolute;
      top: 15px;
      left: 130%;
      width: 45vw;
      display: flex;
      align-items: center;
      color: $phairify_secondary_color_grey;
      font-weight: 600;
      @extend .font_size_1000rem;

      i.mdi {
        font-size: $phairify_icon-size_xl;
        color: rgba($phairify_secondary_color_grey, 0.5);
      }
    }

    @media (max-width: 768px) {
      margin-bottom: 60px !important;
      .instruction {
        top: 102%;
        left: 0;
        width: 100%;
        transform: none;
        position: initial;
      }
    }
  }

  .survey-results__remove-chart {
    &:hover {
      cursor: pointer;
    }

    i.mdi.size-medium {
      font-size: 22px;
      line-height: 22px;
    }
  }

  .report-markdown-wrapper {
    width: 1240px !important;
    min-height: 3488px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -99;
  }

  .phairify-select-wrapper {
    &:after {
      font-size: 22px;
      right: 10px;
    }

    .custom-select {
      height: 100%;
      padding: 10px;
    }
  }
}

</style>
